import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getVariantLowStockList = createAsyncThunk(
  "get-variant-low-stock",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("variant/low-stock", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const variantLowStockSlice = createSlice({
  name: "variantLowStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVariantLowStockList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVariantLowStockList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.variantList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getVariantLowStockList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default variantLowStockSlice.reducer;
